"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.status.pending': 'Oczekujący',
    'onboarding.status.in_progress': 'W Trakcie',
    'onboarding.status.completed': 'Zakończony',
    'onboarding.status.all': 'Wszystkie Statusy',
    'onboarding.status.abandoned': 'Porzucony',
    'onboarding.status.unknown': 'Nieznany',
};
